import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  AiFillCalendar,
  AiFillClockCircle,
  AiOutlineSearch,
} from "react-icons/ai";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
export const OnewayAndReturn = () => {
  return (
    <Container fluid>
      <Container>
        <Row>
          <Col lg="12">
            <div className="oneway py-11">
              <Tabs>
                <TabList>
                  <Tab>One Way</Tab>
                  <Tab>Return</Tab>
                </TabList>

                <TabPanel>
                  <div>
                    <Row className="align-items-center">
                      <Col xl="4" lg="4" sm="12" xs="12">
                        <fieldset>
                          <div className="About_main_images_search">
                            <input
                              placeholder="Pickup Location"
                              className="border-white"
                            ></input>
                            <AiOutlineSearch
                              size={25}
                              className="text-black border-rounded"
                            />
                            {/* <Button>Search</Button> */}
                          </div>
                        </fieldset>
                      </Col>
                      <Col xl="4" lg="4" sm="12" xs="12">
                        <fieldset>
                          <div className="About_main_images_search">
                            <input
                              placeholder="Add Via Location"
                              className="border-white"
                            ></input>
                            <AiOutlineSearch
                              size={25}
                              className="text-black border-rounded"
                            />
                            {/* <Button>Search</Button> */}
                          </div>
                        </fieldset>
                      </Col>
                      <Col xl="4" lg="4" sm="12" xs="12">
                        <fieldset>
                          <div className="About_main_images_search">
                            <input
                              placeholder="Drop off Location"
                              className="border-white"
                            ></input>
                            <AiOutlineSearch
                              size={25}
                              className="text-black border-rounded"
                            />
                            {/* <Button>Search</Button> */}
                          </div>
                        </fieldset>
                      </Col>
                      <Col xl="3" lg="3" sm="12" xs="12">
                        <fieldset>
                          <div className="About_main_images_search">
                            <input
                              placeholder="Pickup Date"
                              className="border-white"
                            ></input>
                            <AiFillCalendar
                              size={25}
                              className="text-black border-rounded"
                            />
                            {/* <Button>Search</Button> */}
                          </div>
                        </fieldset>
                      </Col>
                      <Col xl="3" lg="3" sm="12" xs="12">
                        <fieldset>
                          <div className="About_main_images_search">
                            <input
                              placeholder="Pickup Time"
                              className="border-white"
                              onClick={() => console.log("test")}
                            ></input>
                            <AiFillClockCircle
                              size={25}
                              className="text-black border-rounded"
                            />
                            {/* <Button>Search</Button> */}
                          </div>
                        </fieldset>
                      </Col>
                      <Col xl="4" lg="4" sm="12" xs="12">
                        <fieldset>
                          <div className="About_main_images_search">
                            <select
                              name="format"
                              id="format"
                              className="w-full"
                            >
                              <option selected disabled>
                                Passenger Count
                              </option>
                              <option value="pdf">1</option>
                              <option value="txt">2</option>
                              <option value="txt">3</option>
                              <option value="txt">4</option>
                              <option value="epub">5</option>
                              <option value="fb2">6</option>
                              <option value="mobi">7</option>
                            </select>

                            {/* <Button>Search</Button> */}
                          </div>
                        </fieldset>
                      </Col>
                      <Col xl="2" lg="2" sm="12" xs="12">
                        <fieldset>
                          <div className="webkit">
                            <button
                              className=" w-full py-3 mt-4 rounded-xl text-white"
                              style={{ background: "#1E1E1E" }}
                            >
                              Search
                            </button>
                          </div>
                        </fieldset>
                      </Col>
                      <Col lg="12">
                        <div className="webkit pt-5">
                          <h2 className="text-lg text-white">
                            Or Book By Phone On 0349-3499847
                          </h2>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </TabPanel>
                <TabPanel>
                  <div>
                    <Row className="align-items-center">
                      <Col xl="4" lg="4" sm="12" xs="12">
                        <fieldset>
                          <div className="About_main_images_search">
                            <input
                              placeholder="Pickup Location"
                              className="border-white"
                            ></input>
                            <AiOutlineSearch
                              size={25}
                              className="text-black border-rounded"
                            />
                            {/* <Button>Search</Button> */}
                          </div>
                        </fieldset>
                      </Col>
                      <Col xl="4" lg="4" sm="12" xs="12">
                        <fieldset>
                          <div className="About_main_images_search">
                            <input
                              placeholder="Add Via Location"
                              className="border-white"
                            ></input>
                            <AiOutlineSearch
                              size={25}
                              className="text-black border-rounded"
                            />
                            {/* <Button>Search</Button> */}
                          </div>
                        </fieldset>
                      </Col>
                      <Col xl="4" lg="4" sm="12" xs="12">
                        <fieldset>
                          <div className="About_main_images_search">
                            <input
                              placeholder="Drop off Location"
                              className="border-white"
                            ></input>
                            <AiOutlineSearch
                              size={25}
                              className="text-black border-rounded"
                            />
                            {/* <Button>Search</Button> */}
                          </div>
                        </fieldset>
                      </Col>
                      <Col xl="3" lg="3" sm="12" xs="12">
                        <fieldset>
                          <div className="About_main_images_search">
                            <input
                              placeholder="Pickup Date"
                              className="border-white"
                            ></input>
                            <AiFillCalendar
                              size={25}
                              className="text-black border-rounded"
                            />
                            {/* <Button>Search</Button> */}
                          </div>
                        </fieldset>
                      </Col>
                      <Col xl="3" lg="3" sm="12" xs="12">
                        <fieldset>
                          <div className="About_main_images_search">
                            <input
                              placeholder="Pickup Time"
                              className="border-white"
                              onClick={() => console.log("test")}
                            ></input>
                            <AiFillClockCircle
                              size={25}
                              className="text-black border-rounded"
                            />
                            {/* <Button>Search</Button> */}
                          </div>
                        </fieldset>
                      </Col>
                      <Col xl="4" lg="4" sm="12" xs="12">
                        <fieldset>
                          <div className="About_main_images_search">
                            <select
                              name="format"
                              id="format"
                              className="w-full"
                            >
                              <option selected disabled>
                                Passenger Count
                              </option>
                              <option value="pdf">1</option>
                              <option value="txt">2</option>
                              <option value="txt">3</option>
                              <option value="txt">4</option>
                              <option value="epub">5</option>
                              <option value="fb2">6</option>
                              <option value="mobi">7</option>
                            </select>

                            {/* <Button>Search</Button> */}
                          </div>
                        </fieldset>
                      </Col>
                      <Col xl="2" lg="2" sm="12" xs="12">
                        <fieldset>
                          <div className="webkit">
                            <button
                              className=" w-full py-3 mt-4 rounded-xl text-white"
                              style={{ background: "#1E1E1E" }}
                            >
                              Search
                            </button>
                          </div>
                        </fieldset>
                      </Col>
                      <Col lg="12">
                        <div className="webkit pt-5">
                          <h2 className="text-lg text-white">
                            Or Book By Phone On 0349-3499847
                          </h2>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </TabPanel>
              </Tabs>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};
